import React from "react";
import CandBMonogramNavy from "./CandBMonogramNavy";

function CalebAndBrown() {
  return <CandBMonogramNavy width="57" height="64" />;
}

export default CalebAndBrown;
